import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import api from '../api/api';
import Swal from 'sweetalert2';

const StudentGrades = () => {
  const [grades, setGrades] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  
  const fetchPeriods = async () => {
    const token = localStorage.getItem('access');
    if (!token) return;

    try {
      const response = await api.get('/api/users/periods/', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPeriods(response.data);  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch periods. Please try again later.',
      });
    }
  };

  
  const fetchGrades = async (period) => {
    if (!period) return;

    const token = localStorage.getItem('access');
    if (!token) return;

    setLoading(true); 
    setError(null); 

    try {
      const response = await api.get('/api/users/student-averages/', {
        headers: { Authorization: `Bearer ${token}` },
        params: { period }, 
      });
      setGrades(response.data);  
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch grades. Please try again later.',
      });
    } finally {
      setLoading(false);  
    }
  };

  
  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  
  const handleViewGrades = () => {
    if (selectedPeriod) {
      setLoading(true);
      setTimeout(async () => {
        await fetchGrades(selectedPeriod);
        setLoading(false);  
      }, 3000);
    }
  };

  useEffect(() => {
    fetchPeriods();  
  }, []);

  return (
    <div>
      <h1>Student Grades</h1>

    
      <FormControl fullWidth margin="normal">
        <InputLabel>Period</InputLabel>
        <Select
          label="Period"
          value={selectedPeriod}
          onChange={handlePeriodChange}
        >
          {periods.map((period) => (
            <MenuItem key={period.id} value={period.id}>
              {period.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

  
      <Button
        variant="contained"
        color="primary"
        onClick={handleViewGrades}
        disabled={!selectedPeriod}  
      >
       {loading ? "Loading..." : "View Grades"}
      </Button>

    
      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
        <CircularProgress />
        </div>
    )}

    
      {!loading && grades.length > 0 && (

  <div style={{ marginBottom: '30px' }}>
    <h2>{grades[0].student_name}</h2>
    <h3>{grades[0].grade_class_name}</h3>
    <h4>{grades[0].period_name}</h4>
    <div><strong>Average Score:</strong> {grades[0].average_score}</div>

    <TableContainer sx={{ maxWidth: '400px', margin: '0 auto' }}>  
  <Table
    size="small" 
    sx={{ borderCollapse: 'collapse', width: '100%' }} 
  >
    <TableHead>
      <TableRow>
        <TableCell
          align="center"
          sx={{
            borderRight: '1px solid #ccc',
            fontWeight: 'bold',
            fontSize: '0.75rem', 
            padding: '4px 6px',   
            width: '50%',         
          }}
        >
          Subject
        </TableCell>
        <TableCell
          align="center"
          sx={{
            borderLeft: '1px solid #ccc',
            fontWeight: 'bold',
            fontSize: '0.75rem',  
            padding: '4px 6px',   
            width: '50%',         
          }}
        >
          Final Score
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {grades[0].student_subjects.map((subject, index) => (
        <TableRow key={index}>
          <TableCell
            align="center"
            sx={{
              borderRight: '1px solid #ccc',
              fontSize: '0.7rem',    
              padding: '2px 4px',    
            }}
          >
            {subject.subject_name}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              fontSize: '0.7rem',  
              padding: '2px 4px',    
              color: parseFloat(subject.formatted_final_score) >= 70 ? 'blue' : 'black',
              fontWeight: parseFloat(subject.formatted_final_score) >= 70 ? 'normal' : 'bold',
              width: '50%',          
              borderLeft: '1px solid #ddd',
              borderRight: '1px solid #ddd',
            }}
            dangerouslySetInnerHTML={{ __html: subject.formatted_final_score }}
            />
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
      <div><strong>Rank:</strong> {grades[0].rank}</div>
      <div><strong>Remark:</strong> {grades[0].remark}</div>
    </div>
  </div>
)}
{error && <p style={{ color: 'red' }}>Error: {error}</p>}
</div>
  );
};

export default StudentGrades;

